<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="section">
  <div class="container">
    <div class="columns">
      <div class="column" />
      <div class="column">
        <div class="title">Your charity</div>
        {#if !charity}
          <div class="field">
            <label class="label">Charity name</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Text input"
                bind:value={name}
                on:input={onChangeName} />
            </div>
          </div>

          <div class="block">
            {#if results}
              <p>Select your charity (<a>Not listed?</a>)</p>
              <table class="table is-fullwidth is-hoverable">
                <tbody>
                  {#each results as result}
                    <tr>
                      <td>
                        <div
                          class="block is-clickable"
                          on:click={() => select(result)}>
                          {result.name}
                        </div>
                      </td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            {/if}
          </div>
        {:else}
          <div class="field">
            <label class="label">Charity name</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Text input"
                bind:value={charity.name} />
            </div>
          </div>

          <div class="field">
            <label class="label">Charity number</label>
            <div class="control">
              <input
                disabled
                class="input"
                type="text"
                placeholder="Text input"
                value={charityNumber} />
            </div>
          </div>

          <div class="field">
            <label class="label">Website</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Text input"
                bind:value={charity.website} />
            </div>
          </div>

          <div class="field">
            <label class="label">Postcode</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Text input"
                bind:value={charity.contact.postcode} />
            </div>
          </div>
        {/if}
        <button class="button is-primary" on:click={submit}>Submit</button>
      </div>
      <div class="column" />
    </div>
  </div>
</div>

<script lang="ts">
  import { goto } from "@sveltech/routify";

  import { appState } from "../../../lib/appState";

  import _ from "lodash";

  let name :string;

  let charityNumber :string;

  let results :any[];

  let charity: Charity_v2;

  function setResults(_results :any[]) {
    results = _results;
  }

  const onChangeName = _.debounce(async (event :any) => {
    setResults((await findCharities(event.target.value)).results);
  }, 300);

  async function findCharities(searchTerm :string) {
    const res = await fetch("https://do.agoodthing.org.uk/api/charities", {
      method: "POST",
      body: JSON.stringify({
        find: {
          name: { $regex: `^${searchTerm}`, $options: "i" },
        },
        limit: 10,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return await res.json();
  }

  async function getCharity(name :string) : Promise<CharityInfo> {
    const res = await fetch("https://do.agoodthing.org.uk/api/charity", {
      method: "POST",
      body: JSON.stringify({
        name,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return await res.json();
  }

  async function select(item :any) {
    let charityInfo = await getCharity(item.name);

    charityNumber = charityInfo.charityNumber;

    charity = {
      type: 'EnglandAndWalesRegistered',
      name: charityInfo.name,
      location: charityInfo.location,
      website: charityInfo.website,
      contact: charityInfo.contact,
      description: charityInfo.activities,
      domains: charityInfo.domains,
      image: charityInfo.image,
      info: {
        name: charityInfo.name,
        charityNumber: charityInfo.charityNumber,
        activities: charityInfo.activities,
        areaOfBenefit: charityInfo.areaOfBenefit,
        operations: charityInfo.operations,
        numPeople: charityInfo.numPeople,
        registrations: charityInfo.registrations,
        beneficiaries: charityInfo.beneficiaries,
        causes: charityInfo.causes,
        names: charityInfo.names
      }
    }
  }

  async function submit() {
    await window.firebase
      .firestore()
      .collection("charities_v2")
      .doc($appState.user!.charity)
      .update(charity)
      .then(() => {
        $appState.charity = charity;
        $goto("ready");
      });
  }
</script>
